import { render } from "./EnrollementView.vue?vue&type=template&id=04f26fee"
import script from "./EnrollementView.vue?vue&type=script&lang=js"
export * from "./EnrollementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__